module.exports = __webpack_public_path__ + "img/red_051.4d829146.png";